import { render, staticRenderFns } from "./RulesIncomplete.vue?vue&type=template&id=067a5135&scoped=true&"
import script from "./RulesIncomplete.vue?vue&type=script&lang=js&"
export * from "./RulesIncomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a5135",
  null
  
)

export default component.exports